angular.module('inoApp')
    .config(['$httpProvider', configureAuthInterceptor])
    .factory('httpBuffer', ['$injector', httpBufferFactory])
    .factory('authInterceptor', ['$injector', '$rootScope', '$q', 'config', 'httpBuffer', 'userService', authInterceptorFactory]);

function configureAuthInterceptor($httpProvider) {
    $httpProvider.interceptors.push('authInterceptor');
}

function authInterceptorFactory($injector, $rootScope, $q, config, httpBuffer, userService) {
    var isRefreshingTokens = false;

    var interceptor = {
        request: handleRequest,
        responseError: handleResponseError
    };

    return interceptor;

    function handleRequest(config) {
        // Append the bearer token to all calls if it's present.
        if (userService.currentUser.tokens.accessToken) {
            config.headers = config.headers || {};
            config.headers.Authorization = 'Bearer ' + userService.currentUser.tokens.accessToken;
        }

        return config;
    }

    function handleResponseError(rejection) {
        // If the error was a 401, we might just need to retry for a new token first.
        if (rejection.status === 401 && userService.currentUser.tokens && userService.currentUser.tokens.refreshToken) {

            // Defer until we can re-request a new token
            var deferred = $q.defer();

            // Add the current request to the buffer so we can retry it at a later time
            httpBuffer.append(rejection, deferred);

            if (!isRefreshingTokens) {
                isRefreshingTokens = true;
                refreshTokens();
            }

            return deferred.promise;
        }

        // Wasn't a 401 or we could not get a new token, just trigger the event, reject the response and move on.
        broadcastError(rejection);
        return $q.reject(rejection);
    }

    function refreshTokens() {
        var refreshTokensSuccessCallback = function (response) {
            if (response && response.data && response.data.accessToken && response.data.refreshToken) {
                // Set the tokens with whatever was returned as response.
                userService.currentUser.tokens.accessToken = response.data.accessToken;
                userService.currentUser.tokens.refreshToken = response.data.refreshToken;
                userService.persist();

                // Retry all previously failed requests.
                httpBuffer.retryAll();
            } else {
                // We don't have a token, clear the userService and reject all previous requests.
                userService.clear();
                httpBuffer.rejectAll();

                // After all is done, just broadcast a 401
                broadcastError({ status: 401 });
            }
        }
        var refreshTokensErrorCallback = function (response) {
            // Token retry failed, clear the userService and reject all previous requests.
            userService.clear();
            httpBuffer.rejectAll();

            // After all is done, just broadcast a 401
            broadcastError({ status: 401 });

            return;
        }

        // Can't inject $http directly as will cause a circular ref.
        var $http = $injector.get("$http");

        // Call the refresh token endpoint to try and get some new tokens
        $http
            .post(config.servicesUrl.identity.refreshTokenUrl, { refreshToken: userService.currentUser.tokens.refreshToken })
            .then(refreshTokensSuccessCallback, refreshTokensErrorCallback)
            .finally(function () { isRefreshingTokens = false; });
    }

    function broadcastError(response) {
        $rootScope.$broadcast({
            401: config.events.auth.notAuthenticated,
            403: config.events.auth.notAuthorized,
            419: config.events.auth.notAuthorized,
            440: config.events.auth.notAuthorized
        }[response.status], response);
    }
}

function httpBufferFactory($injector) {
    // Holds all the requests, so they can be re-requested in future.
    var buffer = [];

    // Service initialized later because of circular dependency problem.
    var $http;

    var service = {
        append: append,
        rejectAll: rejectAll,
        retryAll: retryAll
    };

    return service;

    // Appends HTTP request configuration object with deferred response attached to buffer.
    function append(rejection, deferred) {
        buffer.push({
            rejection: rejection,
            deferred: deferred
        });
    }

    // Abandon or reject (if reason provided) all the buffered requests.
    function rejectAll() {
        for (var i = 0; i < buffer.length; ++i) {
            var item = buffer[i];
            item.deferred.reject(item.rejection);
        }

        buffer = [];
    }

    // Retries all the buffered requests clears the buffer.
    function retryAll() {
        for (var i = 0; i < buffer.length; ++i) {
            var item = buffer[i];
            retryHttpRequest(item.rejection.config, item.deferred);
        }
        buffer = [];
    }

    function retryHttpRequest(config, deferred) {
        function successCallback(response) {
            deferred.resolve(response);
        }
        function errorCallback(response) {
            deferred.reject(response);
        }
        $http = $http || $injector.get('$http');
        $http(config).then(successCallback, errorCallback);
    }
}